import { useMemo } from 'react';

import { DonutChart } from '../common/DonutChart';
import { ExpensesSectionLabel } from './ExpensesSectionLabel';
import pt from '../../locales/pt';
import { buildExpenseTypeChartData } from '../../utils/expenseTypeDistribution';
import { formatEUR } from '../../utils/money';
import { cn } from '../../utils/cn';

/**
 * `.pen` → `ds/chart/donut · tipo` (instâncias `NoOwt` / `jpv7N` / `UtyOm`).
 * Interruptor `center` ligado (TOTAL + valor), `foot` desligado e `head`
 * desligado — o título vive fora, no `ds/label/section-heading`
 * (`ExpensesSectionLabel`). Paleta `$group-*`.
 */
export function ExpensesTypeDistributionChart({
  overview,
  isLoading = false,
  className,
}) {
  const data = useMemo(() => buildExpenseTypeChartData(overview), [overview]);
  const total = data[0]?.total ?? 0;

  const heading = (
    <ExpensesSectionLabel
      title={pt.expenses.distribution.title}
      hint={pt.expenses.distribution.hint}
      tooltip={pt.expenses.distribution.tooltip}
    />
  );

  if (isLoading) {
    return (
      <div className={cn('flex min-w-0 flex-col gap-space-5', className)}>
        {heading}
        <DonutChart state="loading" />
      </div>
    );
  }

  if (!data.length) return null;

  return (
    <div
      className={cn('flex w-full min-w-0 flex-col gap-space-5', className)}
      data-testid="expenses-type-distribution"
    >
      {heading}
      <DonutChart
        slices={data}
        bodyLayout="auto-narrow"
        center={{
          label: pt.expenses.distribution.total,
          value: formatEUR(total),
        }}
      />
    </div>
  );
}

export default ExpensesTypeDistributionChart;
